"use client"
import { HStack, Text } from "@chakra-ui/react"
import { Box } from "@chakra-ui/react/box"
import { Flex } from "@chakra-ui/react/flex"
import { Link } from "@chakra-ui/react/link"
import { FC } from "react"

import colors from "simple-color-functions"

import ErrorMessage from "@/components/ErrorMessage"
import { Category } from "@/types/database"
import { ArrowUpRightIcon } from "@/components/icons"

interface CategoryBadgeListProps {
  categories: Category[]
  displayNumber?: number
}

const CategoryBadgeListArticle: FC<CategoryBadgeListProps> = ({
  categories,
  displayNumber,
}) => {
  // console.log('categories', categories);
  const hasCategories = categories.length > 0
  const isCaseStudy = categories.some(
    (category) => category?.slug === "case-study"
  )
  const articleTypeLabel = isCaseStudy ? "Work" : "Article"
  const articleTypeHref = isCaseStudy ? "/work" : "/writing"
  const formattedDisplayNumber =
    typeof displayNumber === "number"
      ? String(displayNumber).padStart(2, "0")
      : "01"

  return (
    <>
      <Flex flexDirection="row">
        <HStack
          alignItems="center"
          columnGap={"0.5rem"}
          justifyContent="flex-start"
          pointerEvents="all"
          rowGap="0.2rem"
          wrap={"wrap"}
        >
          <Link
            className="block"
            href={articleTypeHref}
            textDecoration={"none"}
          >
            <Text
              alignItems="center"
              color="fg.muted"
              display="flex"
              fontFamily={"mono"}
              fontSize="sm"
              fontWeight="medium"
              letterSpacing="0.14em"
              textTransform="uppercase"
            >
              {articleTypeLabel}
            </Text>
          </Link>
          <Text
            alignItems="center"
            color="fg.muted"
            display="flex"
            fontFamily={"mono"}
            fontSize="sm"
            fontWeight="medium"
            letterSpacing="0.14em"
            textTransform="uppercase"
          >
            {" "}
            ·{" "}
          </Text>
          <Box
            alignItems="center"
            color="fg.muted"
            display="flex"
            fontFamily={"mono"}
            fontSize="sm"
            fontWeight="medium"
            letterSpacing="0.14em"
            textTransform="uppercase"
          >
            {formattedDisplayNumber}
          </Box>
          <Box bgColor="fg.muted" h={"1px"} w={6} />
          {hasCategories ? (
            <>
              {categories.map((item: Category) => {
                return (
                  <Box key={item.slug}>
                    {item !== undefined && (
                      <Link
                        className="block"
                        href={`${articleTypeHref}?categories=${item.slug}`}
                        textDecoration={"none"}
                      >
                        <Text
                          _hover={{
                            "& .arrow": {
                              opacity: 1,
                              transform: "translateX(0)",
                              width: "12px",
                            },
                            color: colors(String(item.icon_color))
                              .darken(3)
                              .hex(),
                          }}
                          alignItems="center"
                          color="fg.muted"
                          display="flex"
                          fontFamily={"mono"}
                          fontSize="sm"
                          fontWeight="medium"
                          letterSpacing="0.14em"
                          textTransform="uppercase"
                        >
                          {item.title}
                          <Box
                            as={"span"}
                            className="arrow"
                            css={{
                              "& svg": {
                                height: "12px",
                                width: "12px",
                              },
                            }}
                            ml="0.2rem"
                            opacity={0}
                            rounded="full"
                            transform="translateX(100%)"
                            transition="transform 0.16s ease-in, width 0.16s ease-in, opacity 0.16s ease-in"
                            width="0px"
                            zIndex={12}
                          >
                            <ArrowUpRightIcon />
                          </Box>
                        </Text>
                      </Link>
                    )}
                  </Box>
                )
              })}
            </>
          ) : (
            <ErrorMessage
              message="Please try again."
              title="Unable to locate the work categories!"
            />
          )}
        </HStack>
      </Flex>
    </>
  )
}

export default CategoryBadgeListArticle
